(function (angular) {
    'use strict';

    angular.module('channels')

        /**
         *
         */
        .factory('appMessagingChannelService',
            ['$uibModal', '$state',
                function ($uibModal, $state) {

                    var fac = {
                        getAppleConfig: getAppleConfig,
                        getAndroidConfig: getAndroidConfig,
                        getAuthenticationConfig: getAuthenticationConfig
                    };

                    return fac;

                    function getAppleConfig() {
                        return $state.go('main.apiSpace.channels.push-apple');
                    }
                    function getAndroidConfig() {
                        return $state.go('main.apiSpace.channels.push-android');
                    }
                    function getAuthenticationConfig() {
                        return $uibModal.open({
                            templateUrl: 'components/channels/appMessaging/templates/authentication.html',
                            size: 'md',
                            resolve: {
                                authenticationData: ['$q', '$stateParams', 'authenticationService', function ($q, $stateParams, authenticationService) {
                                    return authenticationService.getAuthConfig($stateParams.pickedApiSpaceId)
                                        .then(function (result) {
                                            return result;
                                        }).catch(function (result) {
                                            var deferred = $q.defer();
                                            if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                            return deferred.promise;
                                        });
                                }]

                            },
                            controller: 'AuthenticationCtrl'
                        });
                    }

                }]);

})(window.angular);